import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import { NotificationsModule } from "@/store/modules/notification.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let RequestedProjectRejectionNotificationComponent = /** @class */ (() => {
    var _a;
    let RequestedProjectRejectionNotificationComponent = class RequestedProjectRejectionNotificationComponent extends Mixins(BaseMixer) {
        UpdateIsActive(notification) {
            if (!notification.isComplete) {
                return;
            }
            NotificationsModule.UpdateIsActive(notification.id);
        }
        UpdateIsSeen() {
            NotificationsModule.UpdateIsSeen(this.notification.id);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], RequestedProjectRejectionNotificationComponent.prototype, "notification", void 0);
    RequestedProjectRejectionNotificationComponent = __decorate([
        Component({
            name: "RequestedProjectRejectionNotificationComponent",
            components: {},
        })
    ], RequestedProjectRejectionNotificationComponent);
    return RequestedProjectRejectionNotificationComponent;
})();
export default RequestedProjectRejectionNotificationComponent;
